import React from "react";
import { Link } from "react-router-dom";

import blogData from "../data/blogData.js";


import "../Css/Blog.css";


const Blog = () => {
  return (
    <>
      {/* HERO */}
      <section className="Blog-hero">
        <div className="Blog-overlay">
          <div className="Blog-hero-content">
            <h1>Blog</h1>
            <p>
              <Link to="/">Home</Link> / <span className="active">Blog</span>
            </p>
          </div>
        </div>
      </section>

      {/* BLOG LIST */}
      <section className="blog-section">
        <div className="blog-container">
          <div className="blog-grid">
            {blogData.map((blog) => (
              <div className="blog-card" key={blog.id}>
                <div className="blog-image">
                  <img src={blog.image} alt={blog.title} />
                </div>

                <div className="blog-meta">
                  <span>By: {blog.author}</span>
                  <span>{blog.date}</span>
                </div>

                <h3 className="blog-title">{blog.title}</h3>

                <p className="blog-desc">{blog.excerpt}</p>

                <Link
                  to={`/blog/${blog.slug}`}
                  className="blog-read"
                >
                  Read More →
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
